export default "__VITE_ASSET__BLDY6NKC__"